import { useEffect, useState } from 'react';
import NetworkService from '../services/NetworkService';

export const useNetwork = () => {
    const [isOnline, setIsOnline] = useState(NetworkService.isNetworkAvailable());

    useEffect(() => {
        const handleOnline = () => setIsOnline(true);
        const handleOffline = () => setIsOnline(false);

        NetworkService.addEventListener('online', handleOnline);
        NetworkService.addEventListener('offline', handleOffline);

        return () => {
            NetworkService.removeEventListener('online', handleOnline);
            NetworkService.removeEventListener('offline', handleOffline);
        };
    }, []);

    return {isOnline};
};
